import PropTypes from 'prop-types';
import { FileXlsIcon } from '@phosphor-icons/react';
import './common.css';

const ExportButton = ({ data, fileName = 'export.xls' }) => {

  const exportToXls = () => {
    if (!data || data.length === 0) return;

    let table = '<table><tr>';

    // 🔹 Dynamic headers
    const headers = Object.keys(data[0]);
    headers.forEach(header => {
      table += `<th>${header}</th>`;
    });

    table += '</tr>';

    // 🔹 Dynamic rows
    data.forEach(row => {
      table += '<tr>';
      headers.forEach(header => {
        table += `<td>${row[header]}</td>`;
      });
      table += '</tr>';
    });

    table += '</table>';

    const blob = new Blob([table], {
      type: 'application/vnd.ms-excel'
    });

    // Bare global, not globalThis.URL — the latter trips CRA's ESLint no-undef
    // and breaks the dev-server compile while tests still pass.
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    a.click();
  };

  return (
    <button type="button" className="export-btn" onClick={exportToXls}>
      <FileXlsIcon className="export-icon" />
      <span className="export-text">Export</span>
    </button>
  );
};

ExportButton.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  fileName: PropTypes.string,
};

export default ExportButton;
